
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export interface ActionResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

export class ServerActionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ServerActionError";
  }
}

export const safeAction = async <T>(
  action: () => Promise<T>,
  errorMessage = "An unexpected error occurred"
): Promise<ActionResponse<T>> => {
  try {
    const data = await action();
    return { success: true, data };
  } catch (error: any) {
    console.error("Action failed:", error);
    return { 
      success: false, 
      error: error.message || errorMessage 
    };
  }
};
